// ================================================================================================
//  Idioma de la aplicación
//
//  Un único sitio donde se resuelve qué idioma está activo, porque hasta ahora cada quien lo
//  leía a su manera:
//    - API mandaba `localStorage.getItem('i18nextLng')` tal cual, que puede ser null (i18n
//      arranca con `lng: 'es'` explícito, así que el detector no escribe nada en localStorage
//      hasta el primer cambio de idioma) o venir con región ("es-ES", "en-US"), que no es lo
//      que espera el backend.
//
//  `getLanguage()` devuelve siempre uno de los idiomas soportados, en dos letras.
// ================================================================================================

import i18n from "../configs/i18n"

export const SUPPORTED_LANGUAGES = ["es", "en"]

export const DEFAULT_LANGUAGE = "es"

// Normaliza cualquier variante ("es-ES", "EN", null) al código de dos letras soportado.
export const normalizeLanguage = (value) => {
  const base = String(value ?? "").toLowerCase().split("-")[0]
  return SUPPORTED_LANGUAGES.includes(base) ? base : DEFAULT_LANGUAGE
}

// Idioma con el que se piden los datos al backend. i18n manda, porque es lo que está
// pintado en pantalla; localStorage es el respaldo por si se llama antes de inicializarlo.
export const getLanguage = () => {
  const current = i18n?.language ?? (typeof localStorage !== "undefined" && localStorage.getItem("i18nextLng"))
  return normalizeLanguage(current)
}

export default getLanguage
